import { ListFieldFilterToolbar } from "@repo/ui";
import { useGetUserFilters } from "./hooks/useGetUserFilters";
import { useIntl } from "react-intl";

interface UsersFiltersProps {
  searchValue: string;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
  isFilterOpen: boolean;
  setIsFilterOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

/** Ispm users: search + filters from the users filters API. */
export default function UsersFilters({
  searchValue,
  setSearchValue,
  isFilterOpen,
  setIsFilterOpen,
}: UsersFiltersProps) {
  const intl = useIntl();
  const { data, isLoading, isError } = useGetUserFilters(isFilterOpen);

  return (
    <ListFieldFilterToolbar
      searchValue={searchValue}
      onSearchChange={setSearchValue}
      isFilterOpen={isFilterOpen}
      onFilterOpenChange={setIsFilterOpen}
      definitions={data}
      isLoading={isLoading}
      isError={isError}
      labels={{
        searchPlaceholder: intl.formatMessage({
          defaultMessage: "Search...",
          id: "nDj/bI",
          description:
            "Placeholder text for the search input used to find user identities",
        }),
        filterButton: intl.formatMessage({
          defaultMessage: "Filter",
          description: "Label for filter button",
          id: "vxq3Bj",
        }),
      }}
      dataTestIds={{
        searchInput: "users-filters-search",
        filterButton: "users-filters-button",
        clearAll: "users-filters-clear-all",
      }}
      searchInputName="searchIdentities"
    />
  );
}
